import { render, staticRenderFns } from "./modal.component.html?vue&type=template&id=b8979552&external"
import script from "./modal.component.vue?vue&type=script&lang=ts"
export * from "./modal.component.vue?vue&type=script&lang=ts"
import style0 from "./modal.component.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports